import React from "react";
import Navbar from "./Essentials/Navbar";
import Footer from "./Essentials/Footer";
import "./Css/Join.css";
import { useLocation } from "react-router-dom";

function Join() {
  const router = useLocation();

  return (
    <div>
      <Navbar />
      <br />
      <div className="join">
        <center className="left">
          <p
            style={{
              color: "#024369",
              fontSize: "1.3rem",
              borderBottom: "3px solid lightblue",
              width: "fit-content"
            }}
          >
            Computer Scientist Aspirant - Recruitment
          </p>
          <table>
            <tr>
              <td>S.No&nbsp;&nbsp;</td>
              <td>DEPT-SPEC&nbsp;&nbsp;</td>
              <td>POST</td>
            </tr>
            <tr>
              <td>1.</td>
              <td>AIRD-AIML</td>
              <td>Research Fellow (RF)</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>CSRD-CNS</td>
              <td>Research Fellow (RF)</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>AIRD-AIML</td>
              <td>Junior Research Fellow (JRF)</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>CSRD-CNS</td>
              <td>Junior Research Fellow (JRF)</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>VPLD-CD</td>
              <td>Research Fellow (RF)</td>
            </tr>
            <tr>
              <td>6.</td>
              <td>VPLD-CD</td>
              <td>Research Assistant (RA)</td>
            </tr>
            <tr>
              <td>7.</td>
              <td>GPLD-CD</td>
              <td>Research Fellow (RF)</td>
            </tr>
            <tr>
              <td>8.</td>
              <td>GPLD-CD</td>
              <td>Research Assistant (RA)</td>
            </tr>
          </table>
        </center>
        <center>
          <p
            style={{
              color: "#024369",
              fontSize: "1.3rem",
              borderBottom: "3px solid lightblue",
              width: "max-content"
            }}
          >
            Software Engineer - Recruitment
          </p>
          <table>
            <tr>
              <td>S.No&nbsp;&nbsp;</td>
              <td>WING-SPEC</td>
              <td>POST</td>
            </tr>
            <tr>
              <td>1.</td>
              <td>VTC-FS</td>
              <td>FullStack developer</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>VTC-NJS</td>
              <td>Node.js expert</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>VTC-RJS</td>
              <td>React.js expert</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>VTC-MADev</td>
              <td>Android developer</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>*-*</td>
              <td>QA analyst</td>
            </tr>
          </table>
        </center>
        <center className="right">
          <p
            style={{
              color: "#024369",
              fontSize: "1.3rem",
              borderBottom: "3px solid lightblue",
              width: "max-content"
            }}
          >
            Trainer - Recruitment
          </p>
          <table>
            <tr>
              <td>S.No&nbsp;&nbsp;</td>
              <td>CAREER ROLE</td>
            </tr>
            <tr>
              <td>1.</td>
              <td>Core Java Trainer</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Python Trainer</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>HTML Trainer</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>Javascript Trainer</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>React Javascript Trainer</td>
            </tr>
            <tr>
              <td>6.</td>
              <td>Android Development Trainer</td>
            </tr>
            <tr>
              <td>7.</td>
              <td>C Programming Trainer</td>
            </tr>
            <tr>
              <td>8.</td>
              <td>Next Javascript Trainer</td>
            </tr>
            <tr>
              <td>9.</td>
              <td>DSA Trainer</td>
            </tr>
            <tr>
              <td>10.</td>
              <td>AIML with Python Trainer</td>
            </tr>
          </table>
        </center>
      </div>
      <center className="join_nfrac">
        <br />
        <br />
        <div
          style={{
            width: window.screen.width > 750 ? "70%" : "80%",
            textAlign: "justify"
          }}
        >
          <p>
            <b>NOTE:</b> NFRAC-ELT (Entry Level Test) is mandatory for all the
            departments other than CSDC. After ELT, your respective department
            will further test you on your skill set and knowledge. Your
            recruitment is not solely based on your academics and entrance exams
            as, what matters the most is your passion and love for the subject.
          </p>
          <p>
            <b>NFRAC-ELT portal: </b>
            <a href="https://nfrac-elt.web.app/">https://nfrac-elt.web.app</a>
            &nbsp;click here to take your entrance exam today. All the best!! -
            Er. P. Rohit V. Acharya
          </p>
          <p>
            Kindly mail us at <b>nfrac.india@zohomail.com</b> for any inquiry or
            contact us on 040-45038114
          </p>
          <br />
          <br />
        </div>
      </center>
      <Footer />
    </div>
  );
}

export default Join;
